import React from 'react';

import DobAndPayerRow from '@manual_encounters/encounter_reconcile/pings/patient/DobAndPayerRow';
import PatientCardHeader from "@manual_encounters/encounter_reconcile/pings/patient/PatientCardHeader";
import EncounterInfoAndPrograms from "@manual_encounters/encounter_reconcile/pings/patient/EncounterInfoAndPrograms";
import {StyledPatientCard} from "@manual_encounters/encounter_reconcile/pings/patient/PatientCard.styles";

const PatientCard = ({ patient}) => {

  return (
    <StyledPatientCard className="patient-card">
      <PatientCardHeader patient={patient}/>
      <DobAndPayerRow patient={patient} />
      <EncounterInfoAndPrograms patient={patient} />
    </StyledPatientCard>
  );
};

export default PatientCard;
